/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import { RecordMetaFieldsFragmentDoc, ReferenceFieldsFragmentDoc, AttachmentFieldsFragmentDoc, RoleFieldsFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllUsersQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.GetAllUsersInput>;
}>;


export type GetAllUsersQuery = { __typename?: 'Query', getAllUsers: Array<{ __typename?: 'UserModel', account_id: string, cognito_id?: string | null, created_at: string, updated_at: string, is_deleted?: boolean | null, vitall_user_id?: number | null, created_user_id?: string | null, email?: string | null, first_name: string, middle_name?: string | null, last_login?: string | null, last_name: string, profile_picture?: string | null, status: Types.UserStatus, title?: string | null, user_id: string, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string }>, account: { __typename?: 'AccountModel', account_id: string, account_name?: string | null } }> };

export type GetAllPatientUsersQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.GetPatientUsersInput>;
  is_vitall?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  assessment_type?: Types.InputMaybe<Types.AssessmentType>;
  is_org?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isPractitioner?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  includeUserPlan?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetAllPatientUsersQuery = { __typename?: 'Query', getAllPatientUsers: Array<{ __typename?: 'UserModel', first_name: string, middle_name?: string | null, last_name: string, last_login?: string | null, vitall_user_id?: number | null, user_id: string, account_id: string, status: Types.UserStatus, group_name?: string | null, open_alert_count?: number, last_alert_date?: string | null, created_user?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string } | null, account?: { __typename?: 'AccountModel', account_id: string, parent_id?: string | null }, parent_account?: { __typename?: 'AccountModel', account_id: string, account_name?: string | null } | null, user_plan?: { __typename?: 'PlanModel', plan_id: string, name: string } | null, plan?: { __typename?: 'UserPlanModel', name: string, credits: Array<{ __typename?: 'PlanCreditModel', id: string, user_id: string, limit?: number | null, interval?: string | null, remaining?: number | null }> } | null, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string, curator_user_id?: string | null, practitioner_user_id?: string | null, status_id?: string | null, date_of_birth?: string | null, recordMeta?: { __typename?: 'RecordMeta', New: number, NeedsReview: number, Draft: number, Published: number } | null, status?: { __typename?: 'StatusModel', private_name: string, public_name: string, status_id: string, color?: string | null, sequence?: number | null, internal: boolean } | null, latest_assessment?: { __typename?: 'AssessmentModel', assessment_id: string, risk_assessment_id?: string | null, type?: Types.AssessmentType | null, completed_at?: string | null, risk_assessment?: { __typename?: 'RiskAssessmentModel', id?: string | null, resourceType?: string | null, status: string, occurrenceDateTime?: string | null, subject: { __typename?: 'Reference', reference?: string | null, type?: string | null, display?: string | null, identifier?: { __typename?: 'Identifier', use?: string | null, system?: string | null, value?: string | null, type?: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null, userSelected?: boolean | null }> | null } | null, period?: { __typename?: 'Period', start?: string | null, end?: string | null } | null } | null }, extension?: Array<{ __typename?: 'Extension', url: string, valueAttachment?: { __typename?: 'Attachment', id?: string | null, contentType?: string | null, language?: string | null, data?: string | null, url?: string | null, size?: number | null, hash?: string | null, title?: string | null, creation?: string | null } | null }> | null, attachments?: Array<{ __typename?: 'Attachment', id?: string | null, contentType?: string | null, language?: string | null, data?: string | null, url?: string | null, size?: number | null, hash?: string | null, title?: string | null, creation?: string | null }> | null } | null } | null, practitioner?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string } | null, curator?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string } | null } | null }> };

export type GetAllNonPatientUsersQueryVariables = Types.Exact<{
  is_vitall?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetAllNonPatientUsersQuery = { __typename?: 'Query', getAllNonPatientUsers: Array<{ __typename?: 'UserModel', first_name: string, middle_name?: string | null, last_name: string, last_login?: string | null, user_id: string, vitall_user_id?: number | null, group_name?: string | null, status: Types.UserStatus, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string } | null, account?: { __typename?: 'AccountModel', account_id: string, parent_id?: string | null }, parent_account?: { __typename?: 'AccountModel', account_id: string, account_name?: string | null } | null }> };

export type GetUserRecordQueryVariables = Types.Exact<{
  input: Types.GetUserInput;
  include_features?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetUserRecordQuery = { __typename?: 'Query', getUserRecord: { __typename?: 'UserModel', first_name: string, middle_name?: string | null, last_name: string, email?: string | null, title?: string | null, status: Types.UserStatus, user_id: string, account_id: string, cognito_id?: string | null, created_at: string, updated_at: string, last_login?: string | null, first_login?: string | null, is_deleted?: boolean | null, vitall_user_id?: number | null, created_user_id?: string | null, toc_completed?: boolean | null, pn_completed?: boolean | null, casl_completed?: boolean | null, profile_picture?: string | null, group_name?: string | null, featuresv2?: Array<string> | null, account: { __typename?: 'AccountModel', account_id: string, account_name?: string | null, account_type?: Types.AccountType | null, owner_id?: string | null, parent_id?: string | null }, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string, validic_id?: string | null, status?: { __typename?: 'StatusModel', status_id: string, internal: boolean, color?: string | null, public_name: string, private_name: string } | null } | null, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }>, users: Array<{ __typename?: 'UserModel', first_name: string, last_name: string, email?: string | null, title?: string | null, status: Types.UserStatus, user_id: string, account_id: string, cognito_id?: string | null, last_login?: string | null, is_deleted?: boolean | null, vitall_user_id?: number | null, created_user_id?: string | null, created_at: string, updated_at: string, profile_picture?: string | null, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }>, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string, status?: { __typename?: 'StatusModel', status_id: string, internal: boolean, color?: string | null, public_name: string, private_name: string } | null } | null }> } };

export type GetUserMfaSettingsQueryVariables = Types.Exact<{
  input: Types.GetUserInput;
}>;


export type GetUserMfaSettingsQuery = { __typename?: 'Query', getUserRecord: { __typename?: 'UserModel', user_id: string, mfa?: { __typename?: 'UserMfaSettingsModel', status: Types.MfaMethod, phone_number?: string | null, phoneVerified: boolean, smsEnabled: boolean, totpEnabled: boolean, emailEnabled: boolean } | null } };

export type GetUserPlanQueryVariables = Types.Exact<{
  input: Types.GetUserInput;
}>;


export type GetUserPlanQuery = { __typename?: 'Query', getUserRecord: { __typename?: 'UserModel', user_id: string, parent_account?: { __typename?: 'AccountModel', account_id: string, account_name?: string | null } | null, plan?: { __typename?: 'UserPlanModel', plan_id: string, name: string, effective_date: string, credits: Array<{ __typename?: 'PlanCreditModel', id: string, user_id: string, limit?: number | null, interval?: string | null, remaining?: number | null, reset_date?: string | null }> } | null } };

export type UpdateUserNameMutationVariables = Types.Exact<{
  input: Types.ChangeUserNameInput;
}>;


export type UpdateUserNameMutation = { __typename?: 'Mutation', changeName: { __typename?: 'UpdateUserResponse', message: string, success: boolean, data?: { __typename?: 'UserModel', first_name: string, middle_name?: string | null, last_name: string, email?: string | null, title?: string | null, status: Types.UserStatus, user_id: string, account_id: string, cognito_id?: string | null, vitall_user_id?: number | null } | null } };

export type AdminUpdateUserNameMutationVariables = Types.Exact<{
  input: Types.ChangeUserNameInput;
}>;


export type AdminUpdateUserNameMutation = { __typename?: 'Mutation', adminChangeName: { __typename?: 'UpdateUserResponse', message: string, success: boolean, data?: { __typename?: 'UserModel', first_name: string, middle_name?: string | null, last_name: string, email?: string | null, title?: string | null, status: Types.UserStatus, user_id: string, account_id: string, cognito_id?: string | null, vitall_user_id?: number | null } | null } };

export type UpdateUserVitallConsentMutationVariables = Types.Exact<{
  input: Types.ChangeUserConsentInput;
}>;


export type UpdateUserVitallConsentMutation = { __typename?: 'Mutation', updateVitallConsent: { __typename?: 'UpdateUserResponse', message: string, success: boolean, data?: { __typename?: 'UserModel', user_id: string, account_id: string, cognito_id?: string | null, vitall_user_id?: number | null, toc_completed?: boolean | null, pn_completed?: boolean | null, casl_completed?: boolean | null } | null } };

export type EmailExistsQueryVariables = Types.Exact<{
  input: Types.EmailExistsInput;
}>;


export type EmailExistsQuery = { __typename?: 'Query', emailExists: boolean };

export type ListUserImportJobsQueryVariables = Types.Exact<{
  input: Types.ListImportJobsInput;
}>;


export type ListUserImportJobsQuery = { __typename?: 'Query', listUserImportJobs: { __typename?: 'ListUserImportJobs', PaginationToken?: string | null, UserImportJobs?: Array<{ __typename?: 'UserImportJob', CompletionDate?: string | null, CompletionMessage?: string | null, CreationDate: string, FailedUsers: number, ImportedUsers: number, JobId: string, JobName: string, SkippedUsers: number, StartDate: string, Status: string, AccountsInGroup: number, JobDetails?: { __typename?: 'JobDetails', group: { __typename?: 'GroupModel', group_id: string, group_name: string }, document: { __typename?: 'DocumentModel', document_id: string, name?: string | null } } | null }> | null } };

export type RegisterAccountMutationVariables = Types.Exact<{
  input: Types.CreateAccountModelInput;
}>;


export type RegisterAccountMutation = { __typename?: 'Mutation', registerAccount: { __typename?: 'RegisterSingleModel', message: string, user: { __typename?: 'UserModel', user_id: string, email?: string | null }, account: { __typename?: 'AccountModel', account_id: string } } };

export type PostUserRecordMutationVariables = Types.Exact<{
  account_id: Types.Scalars['String']['input'];
  input: Types.CreateUserModelInput;
}>;


export type PostUserRecordMutation = { __typename?: 'Mutation', postUserRecord: { __typename?: 'UserModel', first_name: string, middle_name?: string | null, last_name: string, email?: string | null, title?: string | null, status: Types.UserStatus, user_id: string, account_id: string, cognito_id?: string | null, last_login?: string | null, is_deleted?: boolean | null, vitall_user_id?: number | null, created_user_id?: string | null, created_at: string, updated_at: string, profile_picture?: string | null, roles: Array<{ __typename?: 'RoleModel', role_id: string, role_name: string, role_description: string, rank?: number | null, scope?: Types.AccountType | null, created_at: string, updated_at: string }>, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, patient_id: string } | null } };

export type PostUserImportJobMutationVariables = Types.Exact<{
  input: Types.PostImportJobInput;
  groupName: Types.Scalars['String']['input'];
}>;


export type PostUserImportJobMutation = { __typename?: 'Mutation', postUserImportJob: { __typename?: 'UserImportJob', CompletionDate?: string | null, CompletionMessage?: string | null, CreationDate: string, FailedUsers: number, ImportedUsers: number, JobId: string, JobName: string, SkippedUsers: number, StartDate: string, Status: string, ImportedAccounts: number, GroupId: string } };

export type DeleteUserMutationVariables = Types.Exact<{
  input: Types.GetUserInput;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };


export const GetAllUsersDocument = gql`
    query getAllUsers($input: GetAllUsersInput) {
  getAllUsers(input: $input) {
    account_id
    cognito_id
    created_at
    updated_at
    is_deleted
    vitall_user_id
    created_user_id
    email
    first_name
    middle_name
    is_deleted
    last_login
    last_name
    profile_picture
    status
    title
    updated_at
    user_id
    vitall_user_id
    roles {
      role_id
      role_name
    }
    account {
      account_id
      account_name
    }
  }
}
    `;
export function useGetAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
      }
export function useGetAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
// @ts-ignore
export function useGetAllUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export function useGetAllUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllUsersQuery | undefined, GetAllUsersQueryVariables>;
export function useGetAllUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllUsersSuspenseQuery>;
export type GetAllUsersQueryResult = Apollo.QueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const GetAllPatientUsersDocument = gql`
    query getAllPatientUsers($input: GetPatientUsersInput, $is_vitall: Boolean = false, $assessment_type: AssessmentType = BHA, $is_org: Boolean = false, $isPractitioner: Boolean = false, $includeUserPlan: Boolean = false) {
  getAllPatientUsers(input: $input) {
    first_name
    middle_name @include(if: $is_vitall)
    last_name
    last_login
    vitall_user_id
    user_id
    account_id
    status
    group_name @include(if: $is_vitall)
    created_user @include(if: $isPractitioner) {
      user_id
      first_name
      last_name
    }
    account @include(if: $is_vitall) {
      account_id
      parent_id
    }
    parent_account @include(if: $is_vitall) {
      account_id
      account_name
    }
    user_plan @include(if: $includeUserPlan) {
      plan_id
      name
    }
    plan @include(if: $isPractitioner) {
      name
      credits {
        id
        user_id
        limit
        interval
        remaining
      }
    }
    vitall_patient {
      vitall_patient_id
      patient_id
      curator_user_id @include(if: $is_vitall)
      practitioner_user_id
      recordMeta @include(if: $is_vitall) {
        ...RecordMetaFields
      }
      status_id @include(if: $is_vitall)
      status @include(if: $is_vitall) {
        private_name
        public_name
        status_id
        color
        sequence
        internal
      }
      date_of_birth @skip(if: $is_vitall)
      latest_assessment(type: $assessment_type) @include(if: $isPractitioner) {
        assessment_id
        risk_assessment_id
        type
        completed_at
        risk_assessment {
          id
          resourceType
          status
          occurrenceDateTime
          subject {
            ...ReferenceFields
          }
          extension {
            url
            valueAttachment {
              ...AttachmentFields
            }
          }
          attachments {
            ...AttachmentFields
          }
        }
      }
      practitioner {
        user_id
        first_name
        last_name
      }
      curator @include(if: $is_vitall) {
        user_id
        first_name
        last_name
      }
    }
    open_alert_count @include(if: $is_org)
    last_alert_date @include(if: $is_org)
  }
}
    ${RecordMetaFieldsFragmentDoc}
${ReferenceFieldsFragmentDoc}
${AttachmentFieldsFragmentDoc}`;
export function useGetAllPatientUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPatientUsersQuery, GetAllPatientUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPatientUsersQuery, GetAllPatientUsersQueryVariables>(GetAllPatientUsersDocument, options);
      }
export function useGetAllPatientUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPatientUsersQuery, GetAllPatientUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPatientUsersQuery, GetAllPatientUsersQueryVariables>(GetAllPatientUsersDocument, options);
        }
// @ts-ignore
export function useGetAllPatientUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllPatientUsersQuery, GetAllPatientUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllPatientUsersQuery, GetAllPatientUsersQueryVariables>;
export function useGetAllPatientUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPatientUsersQuery, GetAllPatientUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllPatientUsersQuery | undefined, GetAllPatientUsersQueryVariables>;
export function useGetAllPatientUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPatientUsersQuery, GetAllPatientUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllPatientUsersQuery, GetAllPatientUsersQueryVariables>(GetAllPatientUsersDocument, options);
        }
export type GetAllPatientUsersQueryHookResult = ReturnType<typeof useGetAllPatientUsersQuery>;
export type GetAllPatientUsersLazyQueryHookResult = ReturnType<typeof useGetAllPatientUsersLazyQuery>;
export type GetAllPatientUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllPatientUsersSuspenseQuery>;
export type GetAllPatientUsersQueryResult = Apollo.QueryResult<GetAllPatientUsersQuery, GetAllPatientUsersQueryVariables>;
export const GetAllNonPatientUsersDocument = gql`
    query getAllNonPatientUsers($is_vitall: Boolean = false) {
  getAllNonPatientUsers {
    first_name
    middle_name
    last_name
    last_login
    user_id
    vitall_user_id
    group_name
    status
    vitall_patient {
      vitall_patient_id
      patient_id
    }
    account @include(if: $is_vitall) {
      account_id
      parent_id
    }
    parent_account {
      account_id
      account_name
    }
  }
}
    `;
export function useGetAllNonPatientUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllNonPatientUsersQuery, GetAllNonPatientUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNonPatientUsersQuery, GetAllNonPatientUsersQueryVariables>(GetAllNonPatientUsersDocument, options);
      }
export function useGetAllNonPatientUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNonPatientUsersQuery, GetAllNonPatientUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNonPatientUsersQuery, GetAllNonPatientUsersQueryVariables>(GetAllNonPatientUsersDocument, options);
        }
// @ts-ignore
export function useGetAllNonPatientUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllNonPatientUsersQuery, GetAllNonPatientUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllNonPatientUsersQuery, GetAllNonPatientUsersQueryVariables>;
export function useGetAllNonPatientUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllNonPatientUsersQuery, GetAllNonPatientUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllNonPatientUsersQuery | undefined, GetAllNonPatientUsersQueryVariables>;
export function useGetAllNonPatientUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllNonPatientUsersQuery, GetAllNonPatientUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllNonPatientUsersQuery, GetAllNonPatientUsersQueryVariables>(GetAllNonPatientUsersDocument, options);
        }
export type GetAllNonPatientUsersQueryHookResult = ReturnType<typeof useGetAllNonPatientUsersQuery>;
export type GetAllNonPatientUsersLazyQueryHookResult = ReturnType<typeof useGetAllNonPatientUsersLazyQuery>;
export type GetAllNonPatientUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllNonPatientUsersSuspenseQuery>;
export type GetAllNonPatientUsersQueryResult = Apollo.QueryResult<GetAllNonPatientUsersQuery, GetAllNonPatientUsersQueryVariables>;
export const GetUserRecordDocument = gql`
    query getUserRecord($input: GetUserInput!, $include_features: Boolean = false) {
  getUserRecord(input: $input) {
    first_name
    middle_name
    last_name
    email
    title
    status
    user_id
    account_id
    cognito_id
    created_at
    updated_at
    last_login
    first_login
    is_deleted
    vitall_user_id
    created_user_id
    toc_completed
    pn_completed
    casl_completed
    profile_picture
    group_name
    account {
      account_id
      account_name
      account_type
      owner_id
      parent_id
    }
    vitall_patient {
      vitall_patient_id
      patient_id
      validic_id
      status {
        status_id
        internal
        color
        public_name
        private_name
      }
    }
    roles {
      ...RoleFields
    }
    featuresv2 @include(if: $include_features)
    users {
      first_name
      last_name
      email
      title
      status
      user_id
      account_id
      cognito_id
      last_login
      is_deleted
      vitall_user_id
      created_user_id
      created_at
      updated_at
      profile_picture
      roles {
        ...RoleFields
      }
      vitall_patient {
        vitall_patient_id
        patient_id
        status {
          status_id
          internal
          color
          public_name
          private_name
        }
      }
    }
  }
}
    ${RoleFieldsFragmentDoc}`;
export function useGetUserRecordQuery(baseOptions: Apollo.QueryHookOptions<GetUserRecordQuery, GetUserRecordQueryVariables> & ({ variables: GetUserRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRecordQuery, GetUserRecordQueryVariables>(GetUserRecordDocument, options);
      }
export function useGetUserRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRecordQuery, GetUserRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRecordQuery, GetUserRecordQueryVariables>(GetUserRecordDocument, options);
        }
// @ts-ignore
export function useGetUserRecordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserRecordQuery, GetUserRecordQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserRecordQuery, GetUserRecordQueryVariables>;
export function useGetUserRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRecordQuery, GetUserRecordQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserRecordQuery | undefined, GetUserRecordQueryVariables>;
export function useGetUserRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRecordQuery, GetUserRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserRecordQuery, GetUserRecordQueryVariables>(GetUserRecordDocument, options);
        }
export type GetUserRecordQueryHookResult = ReturnType<typeof useGetUserRecordQuery>;
export type GetUserRecordLazyQueryHookResult = ReturnType<typeof useGetUserRecordLazyQuery>;
export type GetUserRecordSuspenseQueryHookResult = ReturnType<typeof useGetUserRecordSuspenseQuery>;
export type GetUserRecordQueryResult = Apollo.QueryResult<GetUserRecordQuery, GetUserRecordQueryVariables>;
export const GetUserMfaSettingsDocument = gql`
    query getUserMfaSettings($input: GetUserInput!) {
  getUserRecord(input: $input) {
    user_id
    mfa {
      status
      phone_number
      phoneVerified
      smsEnabled
      totpEnabled
      emailEnabled
    }
  }
}
    `;
export function useGetUserMfaSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetUserMfaSettingsQuery, GetUserMfaSettingsQueryVariables> & ({ variables: GetUserMfaSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserMfaSettingsQuery, GetUserMfaSettingsQueryVariables>(GetUserMfaSettingsDocument, options);
      }
export function useGetUserMfaSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserMfaSettingsQuery, GetUserMfaSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserMfaSettingsQuery, GetUserMfaSettingsQueryVariables>(GetUserMfaSettingsDocument, options);
        }
// @ts-ignore
export function useGetUserMfaSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserMfaSettingsQuery, GetUserMfaSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserMfaSettingsQuery, GetUserMfaSettingsQueryVariables>;
export function useGetUserMfaSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserMfaSettingsQuery, GetUserMfaSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserMfaSettingsQuery | undefined, GetUserMfaSettingsQueryVariables>;
export function useGetUserMfaSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserMfaSettingsQuery, GetUserMfaSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserMfaSettingsQuery, GetUserMfaSettingsQueryVariables>(GetUserMfaSettingsDocument, options);
        }
export type GetUserMfaSettingsQueryHookResult = ReturnType<typeof useGetUserMfaSettingsQuery>;
export type GetUserMfaSettingsLazyQueryHookResult = ReturnType<typeof useGetUserMfaSettingsLazyQuery>;
export type GetUserMfaSettingsSuspenseQueryHookResult = ReturnType<typeof useGetUserMfaSettingsSuspenseQuery>;
export type GetUserMfaSettingsQueryResult = Apollo.QueryResult<GetUserMfaSettingsQuery, GetUserMfaSettingsQueryVariables>;
export const GetUserPlanDocument = gql`
    query getUserPlan($input: GetUserInput!) {
  getUserRecord(input: $input) {
    user_id
    parent_account {
      account_id
      account_name
    }
    plan {
      plan_id
      name
      effective_date
      credits {
        id
        user_id
        limit
        interval
        remaining
        reset_date
      }
    }
  }
}
    `;
export function useGetUserPlanQuery(baseOptions: Apollo.QueryHookOptions<GetUserPlanQuery, GetUserPlanQueryVariables> & ({ variables: GetUserPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPlanQuery, GetUserPlanQueryVariables>(GetUserPlanDocument, options);
      }
export function useGetUserPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPlanQuery, GetUserPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPlanQuery, GetUserPlanQueryVariables>(GetUserPlanDocument, options);
        }
// @ts-ignore
export function useGetUserPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserPlanQuery, GetUserPlanQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPlanQuery, GetUserPlanQueryVariables>;
export function useGetUserPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPlanQuery, GetUserPlanQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPlanQuery | undefined, GetUserPlanQueryVariables>;
export function useGetUserPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPlanQuery, GetUserPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPlanQuery, GetUserPlanQueryVariables>(GetUserPlanDocument, options);
        }
export type GetUserPlanQueryHookResult = ReturnType<typeof useGetUserPlanQuery>;
export type GetUserPlanLazyQueryHookResult = ReturnType<typeof useGetUserPlanLazyQuery>;
export type GetUserPlanSuspenseQueryHookResult = ReturnType<typeof useGetUserPlanSuspenseQuery>;
export type GetUserPlanQueryResult = Apollo.QueryResult<GetUserPlanQuery, GetUserPlanQueryVariables>;
export const UpdateUserNameDocument = gql`
    mutation updateUserName($input: ChangeUserNameInput!) {
  changeName(input: $input) {
    message
    success
    data {
      first_name
      middle_name
      last_name
      email
      title
      status
      user_id
      account_id
      cognito_id
      vitall_user_id
    }
  }
}
    `;
export type UpdateUserNameMutationFn = Apollo.MutationFunction<UpdateUserNameMutation, UpdateUserNameMutationVariables>;
export function useUpdateUserNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNameMutation, UpdateUserNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserNameMutation, UpdateUserNameMutationVariables>(UpdateUserNameDocument, options);
      }
export type UpdateUserNameMutationHookResult = ReturnType<typeof useUpdateUserNameMutation>;
export type UpdateUserNameMutationResult = Apollo.MutationResult<UpdateUserNameMutation>;
export type UpdateUserNameMutationOptions = Apollo.BaseMutationOptions<UpdateUserNameMutation, UpdateUserNameMutationVariables>;
export const AdminUpdateUserNameDocument = gql`
    mutation adminUpdateUserName($input: ChangeUserNameInput!) {
  adminChangeName(input: $input) {
    message
    success
    data {
      first_name
      middle_name
      last_name
      email
      title
      status
      user_id
      account_id
      cognito_id
      vitall_user_id
    }
  }
}
    `;
export type AdminUpdateUserNameMutationFn = Apollo.MutationFunction<AdminUpdateUserNameMutation, AdminUpdateUserNameMutationVariables>;
export function useAdminUpdateUserNameMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateUserNameMutation, AdminUpdateUserNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateUserNameMutation, AdminUpdateUserNameMutationVariables>(AdminUpdateUserNameDocument, options);
      }
export type AdminUpdateUserNameMutationHookResult = ReturnType<typeof useAdminUpdateUserNameMutation>;
export type AdminUpdateUserNameMutationResult = Apollo.MutationResult<AdminUpdateUserNameMutation>;
export type AdminUpdateUserNameMutationOptions = Apollo.BaseMutationOptions<AdminUpdateUserNameMutation, AdminUpdateUserNameMutationVariables>;
export const UpdateUserVitallConsentDocument = gql`
    mutation updateUserVitallConsent($input: ChangeUserConsentInput!) {
  updateVitallConsent(input: $input) {
    message
    success
    data {
      user_id
      account_id
      cognito_id
      vitall_user_id
      toc_completed
      pn_completed
      casl_completed
    }
  }
}
    `;
export type UpdateUserVitallConsentMutationFn = Apollo.MutationFunction<UpdateUserVitallConsentMutation, UpdateUserVitallConsentMutationVariables>;
export function useUpdateUserVitallConsentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserVitallConsentMutation, UpdateUserVitallConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserVitallConsentMutation, UpdateUserVitallConsentMutationVariables>(UpdateUserVitallConsentDocument, options);
      }
export type UpdateUserVitallConsentMutationHookResult = ReturnType<typeof useUpdateUserVitallConsentMutation>;
export type UpdateUserVitallConsentMutationResult = Apollo.MutationResult<UpdateUserVitallConsentMutation>;
export type UpdateUserVitallConsentMutationOptions = Apollo.BaseMutationOptions<UpdateUserVitallConsentMutation, UpdateUserVitallConsentMutationVariables>;
export const EmailExistsDocument = gql`
    query emailExists($input: EmailExistsInput!) {
  emailExists(input: $input)
}
    `;
export function useEmailExistsQuery(baseOptions: Apollo.QueryHookOptions<EmailExistsQuery, EmailExistsQueryVariables> & ({ variables: EmailExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailExistsQuery, EmailExistsQueryVariables>(EmailExistsDocument, options);
      }
export function useEmailExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailExistsQuery, EmailExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailExistsQuery, EmailExistsQueryVariables>(EmailExistsDocument, options);
        }
// @ts-ignore
export function useEmailExistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailExistsQuery, EmailExistsQueryVariables>): Apollo.UseSuspenseQueryResult<EmailExistsQuery, EmailExistsQueryVariables>;
export function useEmailExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailExistsQuery, EmailExistsQueryVariables>): Apollo.UseSuspenseQueryResult<EmailExistsQuery | undefined, EmailExistsQueryVariables>;
export function useEmailExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailExistsQuery, EmailExistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailExistsQuery, EmailExistsQueryVariables>(EmailExistsDocument, options);
        }
export type EmailExistsQueryHookResult = ReturnType<typeof useEmailExistsQuery>;
export type EmailExistsLazyQueryHookResult = ReturnType<typeof useEmailExistsLazyQuery>;
export type EmailExistsSuspenseQueryHookResult = ReturnType<typeof useEmailExistsSuspenseQuery>;
export type EmailExistsQueryResult = Apollo.QueryResult<EmailExistsQuery, EmailExistsQueryVariables>;
export const ListUserImportJobsDocument = gql`
    query listUserImportJobs($input: ListImportJobsInput!) {
  listUserImportJobs(input: $input) {
    PaginationToken
    UserImportJobs {
      CompletionDate
      CompletionMessage
      CreationDate
      FailedUsers
      ImportedUsers
      JobId
      JobName
      SkippedUsers
      StartDate
      Status
      AccountsInGroup
      JobDetails {
        group {
          group_id
          group_name
        }
        document {
          document_id
          name
        }
      }
    }
  }
}
    `;
export function useListUserImportJobsQuery(baseOptions: Apollo.QueryHookOptions<ListUserImportJobsQuery, ListUserImportJobsQueryVariables> & ({ variables: ListUserImportJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserImportJobsQuery, ListUserImportJobsQueryVariables>(ListUserImportJobsDocument, options);
      }
export function useListUserImportJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserImportJobsQuery, ListUserImportJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserImportJobsQuery, ListUserImportJobsQueryVariables>(ListUserImportJobsDocument, options);
        }
// @ts-ignore
export function useListUserImportJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListUserImportJobsQuery, ListUserImportJobsQueryVariables>): Apollo.UseSuspenseQueryResult<ListUserImportJobsQuery, ListUserImportJobsQueryVariables>;
export function useListUserImportJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUserImportJobsQuery, ListUserImportJobsQueryVariables>): Apollo.UseSuspenseQueryResult<ListUserImportJobsQuery | undefined, ListUserImportJobsQueryVariables>;
export function useListUserImportJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUserImportJobsQuery, ListUserImportJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUserImportJobsQuery, ListUserImportJobsQueryVariables>(ListUserImportJobsDocument, options);
        }
export type ListUserImportJobsQueryHookResult = ReturnType<typeof useListUserImportJobsQuery>;
export type ListUserImportJobsLazyQueryHookResult = ReturnType<typeof useListUserImportJobsLazyQuery>;
export type ListUserImportJobsSuspenseQueryHookResult = ReturnType<typeof useListUserImportJobsSuspenseQuery>;
export type ListUserImportJobsQueryResult = Apollo.QueryResult<ListUserImportJobsQuery, ListUserImportJobsQueryVariables>;
export const RegisterAccountDocument = gql`
    mutation registerAccount($input: CreateAccountModelInput!) {
  registerAccount(input: $input) {
    message
    user {
      user_id
      email
    }
    account {
      account_id
    }
  }
}
    `;
export type RegisterAccountMutationFn = Apollo.MutationFunction<RegisterAccountMutation, RegisterAccountMutationVariables>;
export function useRegisterAccountMutation(baseOptions?: Apollo.MutationHookOptions<RegisterAccountMutation, RegisterAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterAccountMutation, RegisterAccountMutationVariables>(RegisterAccountDocument, options);
      }
export type RegisterAccountMutationHookResult = ReturnType<typeof useRegisterAccountMutation>;
export type RegisterAccountMutationResult = Apollo.MutationResult<RegisterAccountMutation>;
export type RegisterAccountMutationOptions = Apollo.BaseMutationOptions<RegisterAccountMutation, RegisterAccountMutationVariables>;
export const PostUserRecordDocument = gql`
    mutation postUserRecord($account_id: String!, $input: CreateUserModelInput!) {
  postUserRecord(account_id: $account_id, input: $input) {
    first_name
    middle_name
    last_name
    email
    title
    status
    user_id
    account_id
    cognito_id
    last_login
    is_deleted
    vitall_user_id
    created_user_id
    created_at
    updated_at
    profile_picture
    roles {
      ...RoleFields
    }
    vitall_patient {
      vitall_patient_id
      patient_id
    }
  }
}
    ${RoleFieldsFragmentDoc}`;
export type PostUserRecordMutationFn = Apollo.MutationFunction<PostUserRecordMutation, PostUserRecordMutationVariables>;
export function usePostUserRecordMutation(baseOptions?: Apollo.MutationHookOptions<PostUserRecordMutation, PostUserRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostUserRecordMutation, PostUserRecordMutationVariables>(PostUserRecordDocument, options);
      }
export type PostUserRecordMutationHookResult = ReturnType<typeof usePostUserRecordMutation>;
export type PostUserRecordMutationResult = Apollo.MutationResult<PostUserRecordMutation>;
export type PostUserRecordMutationOptions = Apollo.BaseMutationOptions<PostUserRecordMutation, PostUserRecordMutationVariables>;
export const PostUserImportJobDocument = gql`
    mutation postUserImportJob($input: PostImportJobInput!, $groupName: String!) {
  postUserImportJob(input: $input) {
    CompletionDate
    CompletionMessage
    CreationDate
    FailedUsers
    ImportedUsers
    JobId
    JobName
    SkippedUsers
    StartDate
    Status
    ImportedAccounts(groupName: $groupName)
    GroupId(groupName: $groupName)
  }
}
    `;
export type PostUserImportJobMutationFn = Apollo.MutationFunction<PostUserImportJobMutation, PostUserImportJobMutationVariables>;
export function usePostUserImportJobMutation(baseOptions?: Apollo.MutationHookOptions<PostUserImportJobMutation, PostUserImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostUserImportJobMutation, PostUserImportJobMutationVariables>(PostUserImportJobDocument, options);
      }
export type PostUserImportJobMutationHookResult = ReturnType<typeof usePostUserImportJobMutation>;
export type PostUserImportJobMutationResult = Apollo.MutationResult<PostUserImportJobMutation>;
export type PostUserImportJobMutationOptions = Apollo.BaseMutationOptions<PostUserImportJobMutation, PostUserImportJobMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($input: GetUserInput!) {
  deleteUser(input: $input)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetAllUsers = withQueryResponseHandler(useGetAllUsersQuery);
export const useGetAllPatientUsers = withQueryResponseHandler(useGetAllPatientUsersQuery);
export const useGetAllNonPatientUsers = withQueryResponseHandler(useGetAllNonPatientUsersQuery);
export const useGetUserRecord = withQueryResponseHandler(useGetUserRecordQuery);
export const useGetUserMfaSettings = withQueryResponseHandler(useGetUserMfaSettingsQuery);
export const useGetUserPlan = withQueryResponseHandler(useGetUserPlanQuery);
export const useEmailExists = withQueryResponseHandler(useEmailExistsQuery);
export const useListUserImportJobs = withQueryResponseHandler(useListUserImportJobsQuery);
export const useUpdateUserName = withMutationResponseHandler(useUpdateUserNameMutation, "updateUserName");
export const useAdminUpdateUserName = withMutationResponseHandler(useAdminUpdateUserNameMutation, "adminUpdateUserName");
export const useUpdateUserVitallConsent = withMutationResponseHandler(useUpdateUserVitallConsentMutation, "updateUserVitallConsent");
export const useRegisterAccount = withMutationResponseHandler(useRegisterAccountMutation, "registerAccount");
export const usePostUserRecord = withMutationResponseHandler(usePostUserRecordMutation, "postUserRecord");
export const usePostUserImportJob = withMutationResponseHandler(usePostUserImportJobMutation, "postUserImportJob");
export const useDeleteUser = withMutationResponseHandler(useDeleteUserMutation, "deleteUser");